// needed for testing
let endpoint = ''
try {
  endpoint = API_ENDPOINT
} catch (e) {
  endpoint = 'some'
}

// ENDPOINTS
const BADGES_ENDPOINT = endpoint + '/api/v2/badge/backoffice/badges'
const TOKEN_ENDPOINT = endpoint + '/api/v2/auth/backoffice/tk-token?tkAuthToken=xxx111xxx&test=true&partnerId=TALL123457'
const LOGIN_ENDPOINT = endpoint + '/api/v2/auth/backoffice/login'
const LOGOUT_ENDPOINT = endpoint +'/api/v2/auth/backoffice/logout'
const ACCOUNT_ENDPOINT = endpoint + '/api/v2/auth/backoffice/account'
const USER_DETAILS_ENDPOINT = endpoint + '/api/v2/auth/backoffice/account/login-history'
const STEP_DATA_USER_ENDPOINT = endpoint + '/api/v2/activity/backoffice/steps'
const STEP_UPDATE_USER_ENDPOINT = endpoint + '/api/v2/activity/backoffice/update/steps'
const STEP_DATA_ALL_ENDPOINT = endpoint + '/api/v2/activity/backoffice/steps/all'
const STEP_UPDATE_ALL_ENDPOINT = endpoint + '/api/v2/activity/backoffice/update/steps/all'

export default {
  TOKEN_ENDPOINT: TOKEN_ENDPOINT,
  BADGES_ENDPOINT: BADGES_ENDPOINT,
  LOGIN_ENDPOINT: LOGIN_ENDPOINT,
  LOGOUT_ENDPOINT: LOGOUT_ENDPOINT,
  ACCOUNT_ENDPOINT: ACCOUNT_ENDPOINT,
  USER_DETAILS_ENDPOINT: USER_DETAILS_ENDPOINT,
  STEP_DATA_USER_ENDPOINT: STEP_DATA_USER_ENDPOINT,
  STEP_DATA_ALL_ENDPOINT: STEP_DATA_ALL_ENDPOINT,
  STEP_UPDATE_ALL_ENDPOINT: STEP_UPDATE_ALL_ENDPOINT,
  STEP_UPDATE_USER_ENDPOINT: STEP_UPDATE_USER_ENDPOINT
}
